<template>
  <div class="card container-fluid" style="width: 370px;">
    <div class="row">
      <div class="col">
        <!-- Normal title mini -->
        <h6 class="title_login">Iniciar sesion con OAuth by Medisoft</h6>
        <hr class="hr">
        <!-- Image of product section -->
        <div style="text-align: center">
          <img class="product_legal shadow-sm" :src="`data:${data.devApp.iconoExt};base64,${data.devApp.icono}`"> <!-- :src="`data:${data.devApp.iconoExt};base64,${data.devApp.icono}`" alt="" -->
        </div>
        <!-- Formulario de inicio de sesion -->
        <Form ref="Form">
          <Input prop="user" label="Usuario" type="text" v-model="loginInfo.user"/>
          <Input prop="pwd" label="Contraseña" type="password" v-model="loginInfo.pwd"/>
          <div class="buttons_container">
            <button class="btn btn-light btn-sm" @click.prevent="submitChange">Recuperar contraseña</button>
            <button class="btn btn-primary btn-sm" @click.prevent="submitDialog">Iniciar sesion</button>
          </div>
        </Form>
        <!-- Informacion legal -->
        <p style="text-align: left; font-size: 12px; margin-top: 18px; opacity: 0.7;">
          <span>
            {{ `Para continuar, OAuth compartirá tu nombre, tu dirección de correo electrónico y tu foto de perfil con
            ${data.devApp.nombre}. Antes de usar esta aplicación, puedes leer la politica de privacidad y los terminos de servicio cuyos links estan debajo.` }}
          </span>
        </p>
        <hr>
        <!-- Accesos legales -->
        <div class="buttons_legal">
          <button type="button" class="btn btn-link btn-sm" @click.prevent="goto('/download', true)">Descargar administrador</button>
          <button type="button" class="btn btn-link btn-sm" @click.prevent="goto('https://www.faelectronica.com/docs/privacity.pdf', false)">Privacidad</button>
          <button type="button" class="btn btn-link btn-sm" @click.prevent="goto('https://www.faelectronica.com/docs/terms.pdf', false)">Terminos</button>
        </div>
      </div>
    </div>
    <Loading v-if="state === 'load'" :text="action"/>
  </div>
</template>

<script>
import Input from './elements/Input'
import Form from './elements/Form'
import Loading from './elements/Loader'
export default {
  name: 'LoginComponent',
  components: {
    Form,
    Input,
    Loading
  },
  props: {
    data: Object,
    forDev: Boolean,
    withSesion: Boolean,
    mode: String
  },
  data () {
    return {
      state: 'load',
      action: 'Verificando cookies',
      loginRules: [
        { prop: 'user', type: 'empty', message: 'El correo electronico es requerido' },
        { prop: 'user', type: 'email', message: 'El valor especificado no coincide con una direccion de correo' },
        { prop: 'pwd', type: 'empty', message: 'La contraseña es requerida' }
      ],
      changeRules: [
        { prop: 'user', type: 'empty', message: 'El correo electronico es requerido' },
        { prop: 'user', type: 'email', message: 'El valor especificado no coincide con una direccion de correo' }
      ],
      loginInfo: {
        user: '',
        pwd: ''
      },
      profile: null,
      sesion: ''
    }
  },
  mounted () {
    this.verifyCookies()
  },
  methods: {
    goto (path, isThis) {
      if (isThis) {
        this.$router.push({ path: path })
      } else {
        window.open(path, '_blank')
      }
    },
    verifyCookies () {
      // loader
      this.state = 'load'
      this.action = 'Verificando cookies'
      // Verificacion de las cookies
      if (this.$oauthcore.cookie.GetCookies(this.data.public) !== undefined) {
        // en caso de obtencionde cookies
        this.$oauthcore.api.Sesiones.useSesion(this.data.public, this.$oauthcore.cookie.GetCookies(this.data.public)).then((rta) => {
          // Generacion del url para redirigir
          this.urlReturn = this.data.devApp.urlOK.replace('#{useridentifier}#', rta.result).replace('#{sesionidentifier}#', this.$oauthcore.cookie.GetCookies(this.data.public))
          // Se realiza la redireccion
          window.location.replace(this.urlReturn)
        }).catch((e) => {
          // en caso de error se eliminan las cookies
          this.$oauthcore.cookie.DeleteCookies(this.data.public)
          this.state = 'idle'
        })
      } else this.state = 'idle'
    },
    submitDialog () {
      // reestablecer el formulario
      this.$refs.Form.clear()
      // ejecutar pruebas
      const result = this.$refs.Form.validate(this.loginRules)
      // verificar el resultado
      if (result) {
        this.state = 'load'
        // Ejecutamos la creacion de sesion
        this.$oauthcore.api.Sesiones.getUsuarioByCredentials(this.loginInfo.user, this.loginInfo.pwd, this.forDev).then((rta) => {
          // Se asignan los datos
          this.profile = rta.result
          // Se verifica el modo de operacion, en caso que deba crearse sesion
          // En caso contrario se omite el proceso
          if (this.withSesion === true) {
            // Creamos la sesion
            this.$oauthcore.api.Sesiones.createSesion(this.data.public, this.profile.key).then((rta1) => {
              // Actualizamos las Cookies
              this.$oauthcore.cookie.CreateCookies(this.data.public, rta1.result)
              this.state = 'idle'
              // Modo de finalizacion, en caso que se quiera en modo normal, se ejecuta con callback
              // en el caso contrario se ejecuta con postMessage del Popup que lo ejecuta
              if (this.mode === 'normal') {
                this.sesion = rta1.result
                this.urlReturn = this.data.devApp.urlOK.replace('#{useridentifier}#', this.profile.key).replace('#{sesionidentifier}#', this.sesion)
                window.location.replace(this.urlReturn)
              } else if (this.mode === 'popup') {
                window.opener.postMessage({ sesion: this.sesion, profile: this.profile }, '*')
                // Eliminar elemento
                // window.opener.document.remove(window.opener.document.getElementById('sesionManager'))
                window.close()
              }
            }).catch((err1) => {
              // this.$notify.error({
              //   title: this.$t('cNotify_Caption1'),
              //   message: this.$t('cNotify_Message1').replace('#{{Message}}#', err1.help)
              // })
              this.state = 'idle'
              this.urlReturn = this.data.devApp.urlError.replace('#{error-code}#', err1.code)
              window.location.replace(this.urlReturn)
            })
          } else {
            // Enviamos respuesta
            if (this.mode === 'normal') {
              this.urlReturn = this.data.devApp.urlOK.replace('#{useridentifier}#', this.profile.key).replace('#{sesionidentifier}#', 'true')
              window.location.replace(this.urlReturn)
            } else if (this.mode === 'popup') {
              window.opener.postMessage({ profile: this.profile }, '*')
              // window.opener.document.remove(window.opener.document.getElementById('sesionManager'))
              window.close()
            }
          }
        }).catch((err) => {
          this.profile = null
          this.state = 'idle'
          console.log(err)
        })
        console.log(result)
      }
    },
    submitChange () {
      alert('Estamos en una conversion y mejora de nuestro sistema de autenticacion debido a unos inconvenientes, si requieres reestablecer tu cuenta, contacta al soporte tecnico')
      // // reestablecer el formulario
      // this.$refs.Form.clear()
      // // ejecutar pruebas
      // const result = this.$refs.Form.validate(this.changeRules)
      // // verificar el resultado
      // if (result) {
      //   this.state = 'load'
      //   this.$router.push({ path: 'passwordchange', query: { action: 'recovery', profile: this.form.usd, callback: window.location.href } })
      // } else {
      //   this.state = 'idle'
      // }
    }
  }
}
</script>

<style lang="scss">
  .card {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    padding: 10px;
  }
  .hr_login {
    margin: 5px 0 15px 0;
  }
  .title_login {
     opacity: 0.6;
     font-size: 14px;
  }
  .buttons_container {
    margin-top: 5px;
    text-align: right;
    * {
      margin-left: 10px;
      font-weight: 600!important;
    }
  }
  .buttons_legal {
    text-align: center;
    * {
      font-size: 12px!important;
    }
  }
  .product_legal {
    height: 80px;
    padding: 8px;
    margin-bottom: 15px;
  }
</style>
